import React, { useState, useEffect } from 'react';
import { Alert, Card } from 'react-bootstrap';
import useConfirmModal from '../../hooks/useConfirmModal';
import PureEditor from '../pureEditor';
import './testCase.css';

const defaultTitle = 'Remove test case';
const defaultContent = 'Are you sure you want to remove this test case?';

const TestCase = ({
  test,
  options,
  onChange,
  deleteCase,
  moveUp,
  moveDown,
  snapCode,
  reviewCodeSnap,
  index,
  count,
  isReadOnly,
  canReviewCodeSnap,
}) => {
  const { openConfirmModal, ConfirmModal } = useConfirmModal(defaultTitle, defaultContent);
  const [value, setValue] = useState(test.code);
  useEffect(() => {
    setValue(test.code);
  }, [test.code]);

  const removeCase = () => {
    openConfirmModal(deleteCase);
  };

  return (
    <div className="test-case">
      <ConfirmModal title={defaultTitle} content={defaultContent} />
      <Card>
        <Card.Header>
          <div className="test-case-header">
            <span style={{ marginRight: 'auto' }}>{test.title}</span>
            {!isReadOnly && index > 0 && <span className="fas fa-arrow-up" onClick={moveUp} />}
            {!isReadOnly && index < count - 1 && (
              <span className="fas fa-arrow-down" onClick={moveDown} />
            )}
            {canReviewCodeSnap && <button onClick={reviewCodeSnap}>Review code snap</button>}
            {!isReadOnly && <span className="fas fa-trash-alt" onClick={removeCase} />}
          </div>
        </Card.Header>
        <Card.Body>
          <PureEditor
            value={value}
            options={options}
            onChange={(editor, data, value) => {
              setValue(value);
              onChange(value);
            }}
          />
        </Card.Body>
      </Card>

      {test.outcome && test.outcome.every(o => o.result === true) && (
        <Alert variant="success">Passed</Alert>
      )}
      {test.outcome &&
        test.outcome.some(o => o.result === false) &&
        test.outcome.map((o, i) =>
          o.result === false ? (
            <Alert variant="danger" className="failed-block" key={i}>
              <b>Failed #{i + 1}</b>
              <p>
                <b>Expected:</b> {JSON.stringify(o.expected)}
              </p>
              <p>
                <b>Received:</b> {JSON.stringify(o.received)}
              </p>
            </Alert>
          ) : null
        )}
    </div>
  );
};

export default TestCase;
